import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { formatter } from 'components/atoms/input-duration';
import { useTranslation } from 'hooks/use-translation';
import { HelperText01 } from 'ozone/atoms';
import { Half, Icon, Line, Props, Row } from './components';
import { Progress } from './progress';
import { Widget } from './widget';

export const Info: FC<Props> = ({
  projectHours: { total_minutes, budget_hours },
}) => {
  const budgeted_minutes = (budget_hours ?? 0) * 60;
  const remaining_minutes = budgeted_minutes - total_minutes;
  const remaining_hours_label = useTranslation('projects.list.remaining_hours');

  return (
    <>
      <Progress
        total_minutes={total_minutes}
        budget_hours={budget_hours}
        width={256}
        height={8}
      />
      <Row>
        <Half>
          <Widget
            title={useTranslation('projects.list.tracked_hours')}
            value={formatter(total_minutes)}
            percentage={
              budget_hours == null
                ? undefined
                : Math.round((total_minutes * 100) / budgeted_minutes)
            }
          />
        </Half>
        {budget_hours == null ? null : (
          <Half>
            <Widget
              title={remaining_hours_label}
              value={formatter(remaining_minutes)}
              percentage={Math.round(
                (remaining_minutes * 100) / budgeted_minutes,
              )}
            />
          </Half>
        )}
      </Row>
      <Row>
        {budget_hours == null ? (
          <Line>
            <Icon />
            <HelperText01>
              <FormattedMessage id="projects.list.budgeted_hours_missing" />
            </HelperText01>
          </Line>
        ) : (
          <Half data-cy="projects.list.budgeted_hours">
            <Widget
              title={<FormattedMessage id="projects.list.budgeted_hours" />}
              value={formatter(budgeted_minutes)}
            />
          </Half>
        )}
      </Row>
    </>
  );
};
